class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  //原版本
  // open(triggeredBy) {
  //   if (triggeredBy) this.setActiveElement(triggeredBy);
  //   const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
  //   if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
  //   setTimeout(() => {
  //     this.classList.add('animate', 'active');
  //   });

  //   this.addEventListener(
  //     'transitionend',
  //     () => {
  //       const containerToTrapFocusOn = this.classList.contains('is-empty')
  //         ? this.querySelector('.drawer__inner-empty')
  //         : document.getElementById('CartDrawer');
  //       const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
  //       trapFocus(containerToTrapFocusOn, focusElement);
  //     },
  //     { once: true }
  //   );

  //   document.body.classList.add('overflow-hidden');
  // }


  //版本1
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        let containerToTrapFocusOn = null;
        if (this.classList.contains('is-empty')) {
          containerToTrapFocusOn = this.querySelector('.drawer__inner-empty');
        } else {

          containerToTrapFocusOn = document.getElementById('CartDrawer');
        }
        if (containerToTrapFocusOn) {
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        } else {
          console.error("Cart Drawer: Could not find a container to trap focus on.");
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }


  //原版本

  // renderContents(parsedState) {
  //   this.querySelector('.drawer__inner').classList.contains('is-empty') &&
  //     this.querySelector('.drawer__inner').classList.remove('is-empty');
  //   this.productId = parsedState.id;
  //   this.getSectionsToRender().forEach((section) => {
  //     const sectionElement = section.selector
  //       ? document.querySelector(section.selector)
  //       : document.getElementById(section.id);

  //     if (!sectionElement) return;
  //     sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  //   });

  //   setTimeout(() => {
  //     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  //     this.open();
  //   });
  // }



  // 版本1
    /**
   * Renders the contents of the cart drawer from an AJAX response.
   * This enhanced version prevents race conditions and ensures the DOM is
   * in a correct state before trapping focus.
   * @param {object} parsedState - The JSON response from the Shopify Cart API.
   */
    renderContents(parsedState) {
      // 【核心修复】在更新 HTML 之前，先确定购物车的最终状态
      const isCartEmpty = parsedState.item_count === 0;
  
      // 立即更新根元素的 class，确保后续的 open() 判断是正确的
      this.classList.toggle('is-empty', isCartEmpty);
      
      // 用更可靠的方式更新内部 HTML
      const newDrawerContent = this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '#CartDrawer > .drawer__inner');
      const drawerInnerElement = this.querySelector('#CartDrawer > .drawer__inner');
  
      if (drawerInnerElement && newDrawerContent) {
        drawerInnerElement.innerHTML = newDrawerContent;
      } else {
        // 如果 drawer__inner 不存在 (比如第一次加载)，就替换整个 CartDrawer
        const newCartDrawerContent = this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '#CartDrawer');
        const cartDrawerElement = document.getElementById('CartDrawer');
        if(cartDrawerElement && newCartDrawerContent) {
          cartDrawerElement.innerHTML = newCartDrawerContent;
        }
      }
  
      // 更新角标
      const newIconBubble = this.getSectionDOM(parsedState.sections['cart-icon-bubble'], '#cart-icon-bubble');
      const oldIconBubble = document.getElementById('cart-icon-bubble');
      if (newIconBubble && oldIconBubble) {
        oldIconBubble.innerHTML = newIconBubble.innerHTML;
      }
  
      // 重新绑定事件并打开
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
